<template>
  <section style="flex: 1">
    <div class="d-flex funnel-filter">
      <select
        id="select-employer-funnel-one"
        class="form-control w-50"
        v-model="selectedEmployer"
        @change="fetchJobsForSelectedEmployer"
      >
        <option
          :value="{
            name: 'Employer',
            address: { address: '', postal_code: '' },
            city: {
              country_id: null,
              id: null,
              latitude: '',
              longitude: '',
              name: '',
            },
            country: { id: null, name: '', part_of_eu: null, phone_code: '', source: '' },
            id: '',
            is_default: false,
          }"
        >
          Employer
        </option>
        <option v-for="employer in getEmployersDropdown" :key="employer.id" :value="employer">
          {{ employer.name }}
        </option>
      </select>

      <div class="form-group">
        <DropdownCheckbox
          v-model="jobFilterDataModel"
          :options="JobsForEmployerOptions"
          @input="handleFunnelJobFilter"
          name="funnel-one"
          placeholder="Job"
          label="title"
        />
      </div>
    </div>

    <VueFunnelGraph
      v-if="values.length"
      :height="thefunnelHeight"
      :width="theFunnelWidth"
      :labels="labels"
      :values="values"
      :colors="colors"
      :sub-labels="subLabels"
      :direction="direction"
      :display-percentage="false"
      subLabelValue="raw"
      :animated="true"
    />

    <div class="spinner-container text-center" v-if="isLoading">
      <svgHelper v-show="isLoading" name="loadingSpinner" class="ml-auto justify-items-center" />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { VueFunnelGraph } from '../../../Admin/Dashboard/vue-funnel-graph';
import { VueFunnelGraph } from 'vue-funnel-graph-js';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';

import { stagesMixin } from '../../../../mixins/stagesMixin';

export default {
  components: {
    VueFunnelGraph,
    DropdownCheckbox,
  },
  mixins: [stagesMixin],
  data: () => ({
    jobFilterDataModel: [],
    selectedEmployer: {
      name: 'Employer',
      address: { address: '', postal_code: '' },
      city: {
        country_id: null,
        id: null,
        latitude: '',
        longitude: '',
        name: '',
      },
      country: { id: null, name: '', part_of_eu: null, phone_code: '', source: '' },
      id: '',
      is_default: false,
    },
    JobsForEmployerOptions: [],
    labels: ['Not contacted', 'Contacted', 'Interviewing', 'Offered employment', 'Employed'],
    subLabels: [],
    values: [],
    colors: [
      ['#f02800', '#f02800'],
      ['#5bb75b', '#5bb75b'],
      ['#0088cc', '#0088cc'],
      ['#913d8b', '#913d8b'],
      ['#043852', '#043852'],
      ['#FFB178', '#FF3C8E'],
      ['#A0BBFF', '#EC77FF'],
      ['#A0F9FF', '#7795FF'],
    ],
    width: 800,
    height: 288,
    thefunnelHeight: 200,
    theFunnelWidth: 0,
    direction: 'horizontal',
    gradientDirection: 'horizontal',
    isLoading: false,
    objectZero: {
      102: 0,
      103: 0,
      104: 0,
      106: 0,
      107: 0,
    },
    funnelData: [],
    finalObject: {},
  }),
  methods: {
    ...mapActions(['retrieveJobsForEmployerDropdown', 'retrieveFunnelOneData']),

    handleFunnelJobFilter() {
      this.fetchFunnelOnetData(this.jobFilterDataModel);
    },
    fetchJobsForSelectedEmployer() {
      this.isLoading = true;
      if (this.selectedEmployer.name !== 'Employer') {
        this.retrieveJobsForEmployerDropdown({ employerId: this.selectedEmployer.id })
          .then((response) => {
            this.isLoading = false;
            this.JobsForEmployerOptions = response.data;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }

      this.jobFilterDataModel = [];
      this.JobsForEmployerOptions = [];
      this.values = [];

      this.isLoading = false;
    },
    formatResponse(data) {
      /*    console.log('formatResponse: ', data); */

      this.finalObject = {};
      this.funnelData = [];

      /* for (const key in data) {
        let title = Object.keys(data[key])[0];
        let currentData = Object.values(data[key])[0]; 

        if (currentData.length === 0) {
          currentData = {};
        }

        this.finalObject = {
          title,
          data: {
            ...this.objectZero,
            ...currentData,
          },
        };

        this.funnelData.push(this.finalObject);
      } */

      this.funnelData = data.map((item) => {
        return {
          title: item.job_name,
          city: item.city_name,
          data: {
            ...this.objectZero,
            ...item.data,
          },
        };
      });
    },
    fetchFunnelOnetData(listOfIds) {
      /* 
      "Not contacted" - 102
      "Contacted" - 103
      "Interviewing" - 104
      "Offered employment" - 106
      "Offered employment" - 107
      */
      this.isLoading = true;

      this.retrieveFunnelOneData({
        jobads_ids: listOfIds.map((j) => j.id),
      })
        .then((response) => {
          this.formatResponse(response.data);

          const tempSubLabels = [];
          const rows = 5;
          const columns = Math.min(5, this.funnelData.length);
          const tempData = [
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
          ];

          for (let i = 0; i < rows; i++) {
            for (let j = 0; j < columns; j++) {
              const { title, city, data } = this.funnelData[j];
              const templist = Object.values(data);

              if (j === i) {
                tempSubLabels[i] = `${title}, ${city}`;
              }

              tempData[i][j] = templist[i];
            }
          }

          this.subLabels = tempSubLabels;
          this.values = tempData;

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onResizeEventHandler() {},
    debounce: (func, delay) => {
      let timerId;
      return function () {
        clearTimeout(timerId);
        timerId = setTimeout(() => func(this, arguments), delay);
      };
    },
  },
  computed: {
    ...mapGetters(['getFunnelOneData', 'getEmployersDropdown']),
  },

  watch: {
    selectedEmployer(newSelectedEmployer) {
      this.localStoragePlugin.set('funnelOneEmployerSelect', newSelectedEmployer);
    },
    jobFilterDataModel(newSelectedJob) {
      this.localStoragePlugin.set('funnelOneJobSelect', JSON.stringify(newSelectedJob));
    },
  },
  created() {
    window.addEventListener('resize', this.debounce(this.onResizeEventHandler, 500));
  },
  mounted() {
    this.theFunnelWidth = document.getElementById('cardu').offsetWidth;

    if (this.localStoragePlugin.has('funnelOneEmployerSelect')) {
      this.selectedEmployer = this.localStoragePlugin.get('funnelOneEmployerSelect');
    } else {
      this.localStoragePlugin.set('funnelOneEmployerSelect', JSON.stringify(this.selectedEmployer));
    }

    if (this.localStoragePlugin.has('funnelOneJobSelect')) {
      this.jobFilterDataModel = this.localStoragePlugin.get('funnelOneJobSelect');
    }

    if (this.selectedEmployer.name !== 'Employer') {
      this.retrieveJobsForEmployerDropdown({ employerId: this.selectedEmployer.id })
        .then((response) => {
          this.JobsForEmployerOptions = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }

    this.fetchFunnelOnetData(this.jobFilterDataModel);
  },
  destroyed() {
    window.removeEventListener('resize', this.debounce(this.onResizeEventHandler, 500));
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.funnel-filter {
  display: flex;
  padding: 12px;
  .form-control {
    width: 50%;
    flex-shrink: 0;
  }
  .form-group {
    width: 50%;
    flex-shrink: 0;
  }
  .dropdown-toggle {
    display: block;
    width: 100%;
  }
}

.graphs,
#wrapper {
  overflow: hidden;
  .card-custom {
    margin: 0 0 30px 0 !important;
    height: 420px;
  }
  .row {
    padding-left: 9px;
    padding-right: 9px;
  }
}
.graphs {
  font-family: $font-family-sans-lato !important;
}
</style>
